// @flow
import React, { Component } from 'react';

import PatternTile from '../PatternTile/PatternTile';
import PatternDetail from '../PatternDetail/PatternDetail';
import Loader from '../Loader/Loader';
import './PatternGrid.css';
import PatternService from '../../services/pattern';


let parseQueryStr = (qstr) => {
    let query = {},
        a = (qstr[0] === '?' ? qstr.substr(1) : qstr).split('&');

    for (let i = 0, len = a.length; i < len; i++) {
        let b = a[i].split('=');
        query[decodeURIComponent(b[0])] = decodeURIComponent(b[1] || '');
    }

    return query;
}


export default class PatternGrid extends Component {

    constructor(props) {
        super(props);

        this.patternService = new PatternService();

        this.state = {
            patterns: [],
        };
    }


    componentDidMount() {

        this.patternService.getAll().then((patterns) => {

            setTimeout(() => {
                this.setState(() => ({
                    patterns: patterns,
                }));

            }, 500);

        });
    }


    render () {
        if (this.state.patterns.length === 0) {
            return (
                <div
                    className="row">
                    <div
                        className="ln-detail">
                        <Loader />
                    </div>
                </div>
            );
        }

        let tiles = this.state.patterns.map((pattern) => {
            return <PatternTile
                key={ pattern.id }
                history={ this.props.history }
                pattern={ pattern } />;
        }),
        detail;

        if (this.props.location.search &&
                this.props.location.search.length > 0) {
            let params = parseQueryStr(this.props.location.search);

            if (params.id) {
                detail = <PatternDetail
                    id={ params.id }
                    mid={ params.mid }
                    history={ this.props.history } />;
            }
        }

        return (
            <div>
                <div
                    className="row">

                    <div
                        className="ln-info-box">
                        kliknij na wzór, żeby zobaczyć więcej
                    </div>

                    { tiles }

                </div>
                { detail }
            </div>);
    }
}



// WEBPACK FOOTER //
// ./src/components/PatternGrid/PatternGrid.js